import { get, writable } from "svelte/store"
import type Prompt from "./Prompt.svelte"
import type Notice from "./Notice.svelte"
import type Authenticate from "../forms/Authenticate.svelte"
import type FontSize from "@components/bottomPopup/FontSize.svelte";

type Components =
    | typeof Prompt
    | typeof Authenticate
    | typeof Notice
    | typeof FontSize
type PopupProfile = { component: Components; props: Record<string, unknown> }
export const componentStore = writable<PopupProfile>()

export const queue: PopupProfile[] = []

export const bottomPopupOpen = writable(false) // for logic
export const bottomPopupShowing = writable(false) // for animation
export function openBottomPopup(
    component: Components,
    props: Record<string, unknown> = {}
) {
    if (get(bottomPopupShowing)) {
        queue.push({ component, props })
    } else {
        componentStore.set({ component, props })
        bottomPopupOpen.set(true)
        bottomPopupShowing.set(true)
    }
}

export function closeBottomPopup() {
    bottomPopupOpen.set(false)
}
